import { connect } from 'react-redux';
import MoreLikeThis from './more_like_this';
import {
  hideMoreLikeThis, loadMoreLikeThis, showMoreLikeThis, showWorks
} from '../../actions/more_like_this';
import { addToCanvas } from '../../actions/canvas';
import { togglePin } from '../../actions/pin';

const mapStateToProps = ({ moreLikeThis, pin }) => ({ ...moreLikeThis, ...pin });

export default connect(mapStateToProps, {
  hideMoreLikeThis, loadMoreLikeThis, showMoreLikeThis, addToCanvas, togglePin, showWorks
})(MoreLikeThis);
